<template>
  <v-card class="ml-2 mb-2 rounded-lg" align="center" elevation="12">
    <h2 class="tw-text-center mt-2 mb-0">
      <router-link
        :to="{ name: 'merchant.reports.batch.settlements'}"
        class="link-text"
      >
      Recent Batches
      </router-link>
    </h2>
    <div class="card-container vertical mb-5">
      <div class="card pt-0">
        <v-simple-table dense>
          <thead>
            <tr class="main-tr">
              <th class="text-center">Date</th>
              <th class="text-center">Transactions</th>
              <th class="text-center">Volume</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tw-text-center" v-for="(batch, i) in data.recentBatches" :key="i">
              <td>
              <router-link
                class="link-text"
                :to="{
                  name: 'merchant.batches.view',
                  params: { id: batch.id },
                }"
              >
               {{ batch.date | dateMedium }}
              </router-link>
              </td>
              <td>{{ batch.transactions | simpleNumber }}</td>
              <td :class="refundClass(batch.volume)">
                {{ dollarFormattedValue(batch.volume) }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </div>
  </v-card>
</template>

<script>
import { refundClass, dateFormattedValue } from '@/common/util/dashboard.util';


export default {
  props: {
    data: {
      required: true,
    },
  },
  methods: {
    refundClass,
    dateFormattedValue,
    dollarFormattedValue(value) {
      const format = this.$options.filters.dollarsAndCents;
      return value ? `$${format(value)}` : null;
    },
  },
};
</script>
